"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dateFilter = void 0;
var _dateFns = require("date-fns");
var _get = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var dateFilter = exports.dateFilter = function dateFilter(item) {
  var startDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var endDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Date.now();
  var timeStamp = arguments.length > 3 ? arguments[3] : undefined;
  var rawTimeStamp = (0, _get["default"])(item, timeStamp);
  if (!rawTimeStamp) {
    console.warn("order history item does not have a ".concat(timeStamp, " property:"), item);
    return false;
  }
  if ((0, _dateFns.isDate)(startDate) && (0, _dateFns.isDate)(endDate)) {
    try {
      return (0, _dateFns.isWithinInterval)(new Date(rawTimeStamp), {
        start: startDate,
        end: (0, _dateFns.addDays)(endDate, 1)
      });
    } catch (_unused) {
      return false;
    }
  }
  try {
    return (0, _dateFns.isWithinInterval)(new Date(rawTimeStamp), {
      start: new Date(0),
      end: new Date()
    });
  } catch (_unused2) {
    return false;
  }
};